import React, { useEffect, useState } from "react";
import "./add-edit-tenant-form.css";
import IAddTenant from "../../../../models/Form/IAddUpdateTenant";
import Label from "../../../../shared-components/Label/Label";
import FormikFormTextArea from "../../../../shared-components/FormikFormHandlers/FormikFormTextArea";
import { formatMessage } from "../../../../translations/format-message";
import { Tooltip } from "react-tooltip";
import FormikFormCheckBox from "../../../../shared-components/FormikFormHandlers/FormikFormCheckBox";
import { FormattedMessage } from "react-intl";
import {
  addTenantDetailsValidateSchema,
  editTenantDetailsValidateSchema,
  organizationDetailValidateSchema,
} from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { Field, Form, Formik, useFormikContext } from "formik";
import FormikFormInput from "../../../../shared-components/FormikFormHandlers/FormikFormInput";
import LoaderButton from "../../../../shared-components/Button/LoaderButton";
import { Button } from "react-bootstrap";
import { observer } from "mobx-react";
import FormLoader from "../../../../shared-components/FormLoader/FormLoader";
import { getThemeFromLocalStorage } from "../../../../helpers/local-stotrage-helper";
import config from "../../../../helpers/config-helper";
import { useStore } from "../../../../contexts/StoreProvider";

interface IProps {
  Id: number;
  initialValues: IAddTenant;
  submitHandler: (data: any) => void;
  isLoading: boolean;
  modalClosed: () => void;
}

const appConfig = config();
const is2FEnabled = appConfig.IS_2F_ENABLED;

const AddUpdateTenantForm1 = (props: IProps) => {
  const { initialValues, submitHandler, isLoading } = props;

  const [data, setData] = useState({ ...initialValues });

  const [currentStep, setCurrentStep] = useState<number>(0);

  useEffect(() => {
    setData({ ...initialValues });
  }, [initialValues]);

  const handleNextStep = (newData: any, final: boolean = false) => {
    setData((prev) => ({ ...prev, ...newData }));
    if (final) {
      let tempValues: IAddTenant = { ...newData };
      tempValues.MaxUserAllow = Number(newData.MaxUserAllow);
      tempValues.MaxDeviceAllow = Number(newData.MaxDeviceAllow);
      submitHandler(tempValues);
      return;
    }
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = (newData: any) => {
    setData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
  };

  const StepOne = (props1: any) => {
    const [showHidePassword, setShowHidePassword] = useState(false);
    const handleSubmit = (values: any) => {
      props1.next(values);
    };
    return (
      <Formik
        initialValues={props1.data}
        onSubmit={handleSubmit}
        validationSchema={
          props.Id == -1
            ? addTenantDetailsValidateSchema
            : editTenantDetailsValidateSchema
        }
        validateOnBlur={false}
        enableReinitialize
      >
        {({ values, isValid }) => (
          <Form id="formBody">
            <div className="pt-3">
              <div className="progress px-1 step-progress">
                <div className="progress-bar" role="progressbar"></div>
              </div>
              <div className="step-container d-flex justify-content-between">
                <div className="step active">
                  <div className="step-circle">
                    <svg
                      id="fi_3683214"
                      fill="currentColor"
                      viewBox="0 0 6.3499999 6.3500002"
                    >
                      <g id="layer1" transform="translate(0 -290.65)">
                        <path
                          id="circle2859"
                          d="m3.0392204 290.9074c-.9238131 0-1.6774171.75619-1.6774171 1.68 0 .56472.2825769 1.06508.7126182 1.36943-1.0030521.40191-1.71462415 1.38264-1.71462415 2.52697a.2646485.2646485 0 0 0 .52916669 0c0-1.21445.97920836-2.19315 2.19366446-2.19315.42393 0 .8174427.12085 1.1523845.32815a.26545233.26545233 0 1 0 .2790529-.45165c-.150926-.0934-.3147642-.16654-.4836914-.22945.4161642-.30591.6888467-.79685.6888467-1.3503-.0000011-.92381-.7561877-1.68-1.6800008-1.68zm0 .52968c.63783 0 1.1508341.51249 1.1508341 1.15032s-.5130041 1.14825-1.1508341 1.14825-1.1482504-.51042-1.1482504-1.14825c.000001-.63783.5104204-1.15032 1.1482504-1.15032zm2.6778729 3.17552a.26460982.26460982 0 0 0 -.214974.12144l-.9120891 1.36684-.572058-.38292a.26565215.26565215 0 1 0 -.2950726.44183l.7953004.52917a.26460982.26460982 0 0 0 .3669025-.0744l1.0588503-1.58801a.26460982.26460982 0 0 0 -.2268595-.41393z"
                          font-variant-ligatures="normal"
                          font-variant-position="normal"
                          font-variant-caps="normal"
                          font-variant-numeric="normal"
                          font-variant-alternates="normal"
                          font-feature-settings="normal"
                          text-indent="0"
                          text-align="start"
                          text-decoration-line="none"
                          text-decoration-style="solid"
                          text-decoration-color="rgb(0,0,0)"
                          text-transform="none"
                          text-orientation="mixed"
                          white-space="normal"
                          shape-padding="0"
                          mix-blend-mode="normal"
                          solid-color="rgb(0,0,0)"
                          solid-opacity="1"
                          vector-effect="none"
                          paint-order="stroke fill markers"
                        ></path>
                      </g>
                    </svg>
                  </div>{" "}
                  <FormattedMessage id="user_information" />
                </div>
                <div className="step">
                  <div className="step-circle">
                    <svg
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 480 480"
                      fill="currentColor"
                    >
                      <g>
                        <path
                          d="M472,464h-48V200c0-4.418-3.582-8-8-8H304V8c0-4.418-3.582-8-8-8H88c-4.418,0-8,3.582-8,8v456H8c-4.418,0-8,3.582-8,8
      s3.582,8,8,8h464c4.418,0,8-3.582,8-8S476.418,464,472,464z M168,464h-32v-72c0-4.418,3.582-8,8-8h16c4.418,0,8,3.582,8,8V464z
        M200,200v264h-16v-72c0-13.255-10.745-24-24-24h-16c-13.255,0-24,10.745-24,24v72H96V16h192v176h-80
      C203.582,192,200,195.582,200,200z M408,464H216V208h192V464z"
                        ></path>
                        <path
                          d="M256,112h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C264,115.582,260.418,112,256,112z
        M248,160h-32v-32h32V160z"
                        ></path>
                        <path
                          d="M256,32h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V40C264,35.582,260.418,32,256,32z
        M248,80h-32V48h32V80z"
                        ></path>
                        <path
                          d="M176,112h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C184,115.582,180.418,112,176,112z
        M168,160h-32v-32h32V160z"
                        ></path>
                        <path
                          d="M176,32h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V40C184,35.582,180.418,32,176,32z
        M168,80h-32V48h32V80z"
                        ></path>
                        <path
                          d="M176,192h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C184,195.582,180.418,192,176,192z
        M168,240h-32v-32h32V240z"
                        ></path>
                        <path
                          d="M176,272h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C184,275.582,180.418,272,176,272z
        M168,320h-32v-32h32V320z"
                        ></path>
                        <path
                          d="M328,368h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C320,364.418,323.582,368,328,368z
        M336,320h32v32h-32V320z"
                        ></path>
                        <path
                          d="M328,288h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C320,284.418,323.582,288,328,288z
        M336,240h32v32h-32V240z"
                        ></path>
                        <path
                          d="M328,448h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C320,444.418,323.582,448,328,448z
        M336,400h32v32h-32V400z"
                        ></path>
                        <path
                          d="M248,368h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C240,364.418,243.582,368,248,368z
        M256,320h32v32h-32V320z"
                        ></path>
                        <path
                          d="M248,288h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C240,284.418,243.582,288,248,288z
        M256,240h32v32h-32V240z"
                        ></path>
                        <path
                          d="M248,448h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C240,444.418,243.582,448,248,448z
        M256,400h32v32h-32V400z"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <FormattedMessage id="organisation_information" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="tenant_name"
                  />
                  <Field
                    data-testid="TenantName"
                    className="form-control"
                    name="TenantName"
                    placeholder="tenant_name"
                    type="text"
                    validcharacter={["@", "#", "$", "-", "_", "."]}
                    as={FormikFormInput}
                  />
                </div>
              </div>

              <div className={` ${props.Id > 0 ? "col-12" : "col-6"}`}>
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="tenant_email"
                  />
                  <Field
                    data-testid="Email"
                    className="form-control"
                    name="Email"
                    placeholder="tenant_email"
                    type="text"
                    invalidcharacter={[" "]}
                    validcharacter={[
                      "-",
                      "_",
                      "[",
                      "]",
                      "(",
                      ")",
                      ":",
                      "#",
                      "@",
                      ".",
                    ]}
                    as={FormikFormInput}
                  />
                </div>
              </div>

              {props.Id == -1 && (
                <div className="col-12 col-sm-6">
                  <div className="form-group formSet">
                    <Label
                      className="label-style"
                      required={true}
                      label="password"
                    />
                    <Field
                      data-testid="Password"
                      className="form-control"
                      name="Password"
                      placeholder="password"
                      autoComplete="new-password"
                      type={showHidePassword ? "text" : "password"}
                      invalidcharacter={[" "]}
                      validcharacter={[
                        "~",
                        "`",
                        "!",
                        "@",
                        "#",
                        "$",
                        "%",
                        "^",
                        "&",
                        "*",
                        "(",
                        ")",
                        "_",
                        "-",
                        "+",
                        "=",
                        "{",
                        "[",
                        "}",
                        "]",
                        "|",
                        "\\",
                        ":",
                        ";",
                        "'",
                        '"',
                        "<",
                        ",",
                        ">",
                        ".",
                        "?",
                        "/",
                      ]}
                      as={FormikFormInput}
                    />
                    {showHidePassword ? (
                      <svg
                        type="button"
                        onClick={() => {
                          setShowHidePassword(!showHidePassword);
                        }}
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="showHidePass css-i6dzq1 tenantBox"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    ) : (
                      <svg
                        type="button"
                        onClick={() => {
                          setShowHidePassword(!showHidePassword);
                        }}
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="showHidePass css-i6dzq1 tenantBox"
                      >
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                        <line x1="1" y1="1" x2="23" y2="23"></line>
                      </svg>
                    )}
                  </div>
                </div>
              )}
              <div className="col-12 col-sm-6">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="user_limit"
                  />
                  <Field
                    data-testid="user_limit"
                    className="form-control"
                    name="MaxUserAllow"
                    placeholder="user_limit"
                    type="number"
                    as={FormikFormInput}
                  />
                </div>
              </div>

              <div className="col-12 col-sm-6">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="device_limit"
                  />
                  <Field
                    data-testid="DeviceLimit"
                    className="form-control"
                    name="MaxDeviceAllow"
                    placeholder="device_limit"
                    type="number"
                    as={FormikFormInput}
                  />
                </div>
              </div>
              {is2FEnabled && (
                <div className="col-md-4 col-12 mt-1">
                  <div className="checkbox">
                    <label>
                      <Field
                        data-testid="IsTwoFactorEnable"
                        className="form-control"
                        name="IsTwoFactorEnable"
                        role="switch"
                        type="checkbox"
                        id="inlineFormCheck"
                        as={FormikFormCheckBox}
                      />
                      <span className="cr">
                        <i className="cr-icon fas fa-check"></i>
                      </span>
                    </label>
                    <label className="h">
                      <FormattedMessage id="two_factor_enable" />
                    </label>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-info-circle ms-2"
                      viewBox="0 0 16 16"
                      data-tooltip-id="two_factor_enable_tooltip"
                      data-tooltip-html={formatMessage(
                        "two_factor_enable_info"
                      )}
                      data-tooltip-variant="dark"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                    </svg>
                    <Tooltip
                      id="two_factor_enable_tooltip"
                      place="right"
                      className={
                        getThemeFromLocalStorage() ? "dark-theme-wrap" : ""
                      }
                    />
                  </div>
                </div>
              )}
              <div
                className={`${
                  is2FEnabled ? "col-md-4" : "col-md-3"
                } col-12 mt-1`}
              >
                <div className="checkbox">
                  <label>
                    <Field
                      data-testid="IsActive"
                      className="form-control"
                      name="IsActive"
                      role="switch"
                      type="checkbox"
                      id="inlineFormCheck"
                      as={FormikFormCheckBox}
                    />
                    <span className="cr">
                      <i className="cr-icon fas fa-check"></i>
                    </span>
                  </label>
                  <label className="h">
                    <FormattedMessage id="is_active" />
                  </label>
                </div>
              </div>
              <div
                className={`${
                  is2FEnabled ? "col-md-4" : "col-md-3"
                } col-12 mt-1`}
              >
                <div className="checkbox">
                  <label>
                    <Field
                      data-testid="IsDataPakcetsStoreInDB"
                      className="form-control"
                      name="IsDataPakcetsStoreInDB"
                      role="switch"
                      type="checkbox"
                      id="inlineFormCheck"
                      as={FormikFormCheckBox}
                    />
                    <span className="cr">
                      <i className="cr-icon fas fa-check"></i>
                    </span>
                  </label>
                  <label className="h">
                    <FormattedMessage id="store_in_DB" />
                  </label>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-info-circle ms-2"
                    viewBox="0 0 16 16"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-html={formatMessage("store_in_db_tenant_info")}
                    data-tooltip-variant="dark"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                  </svg>
                  <Tooltip
                    id="my-tooltip"
                    place="right"
                    className={
                      getThemeFromLocalStorage() ? "dark-theme-wrap" : ""
                    }
                  />
                </div>
              </div>
              <div
                className={`${
                  is2FEnabled ? "col-md-4" : "col-md-3"
                } col-12 mt-1 d-flex`}
              >
                <div className="checkbox">
                  <label>
                    <Field
                      data-testid="SendThresholdAlert"
                      className="form-control"
                      name="SendThresholdAlert"
                      role="switch"
                      type="checkbox"
                      id="inlineFormCheck"
                      as={FormikFormCheckBox}
                    />
                    <span className="cr">
                      <i className="cr-icon fas fa-check"></i>
                    </span>
                  </label>
                  <label className="h">
                    <FormattedMessage id="send_alert" />
                  </label>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-info-circle ms-2"
                    viewBox="0 0 16 16"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-html={formatMessage("send_alert_info")}
                    data-tooltip-variant="dark"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                  </svg>
                  <Tooltip
                    id="my-tooltip"
                    place="right"
                    className={
                      getThemeFromLocalStorage() ? "dark-theme-wrap" : ""
                    }
                  />
                </div>
              </div>
              <div
                className={`${
                  is2FEnabled ? "col-md-4" : "col-md-3"
                } col-12 mt-1 d-flex`}
              >
                <div className="checkbox">
                  <label>
                    <Field
                      data-testid="BlockTenantOnThresholdLimitReached"
                      className="form-control"
                      name="BlockTenantOnThresholdLimitReached"
                      role="switch"
                      type="checkbox"
                      id="inlineFormCheck"
                      as={FormikFormCheckBox}
                    />
                    <span className="cr">
                      <i className="cr-icon fas fa-check"></i>
                    </span>
                  </label>
                  <label className="h">
                    <FormattedMessage id="block_tenant" />
                  </label>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-info-circle ms-2"
                    viewBox="0 0 16 16"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-html={formatMessage("block_tenant_info")}
                    data-tooltip-variant="dark"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                  </svg>
                  <Tooltip
                    id="my-tooltip"
                    place="right"
                    className={
                      getThemeFromLocalStorage() ? "dark-theme-wrap" : ""
                    }
                  />
                </div>
              </div>
            </div>
            <div className="pb-3 mt-3 d-flex justify-content-center">
              <LoaderButton
                type="submit"
                id="SaveTenant"
                isLoading={false}
                text="next"
              />
              {props.Id > 0 && (
                <LoaderButton
                  type={isValid ? "submit" : "button"}
                  id="SaveTenant"
                  onClick={
                    isValid
                      ? () => {
                          props1.next(values, true);
                        }
                      : undefined
                  }
                  isLoading={props.isLoading}
                  text="update"
                  className="ms-3"
                />
              )}
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  const StepTwo = (props2: any) => {
    const { tenantStore } = useStore();
    const { GenerateOrgIdForTenantService } = tenantStore;

    const handleSubmit = (values: any) => {
      let tempValues = {
        ...values,
        BillingAddress:
          values.IsBillingAddressSame === true
            ? values.ShippingAddress
            : values.BillingAddress,
      };
      props2.next({ ...tempValues }, true);
    };

    const FormObserver: React.FC = () => {
      const { values, setFieldValue } = useFormikContext<IAddTenant>();

      useEffect(() => {
        if (values.IsBillingAddressSame) {
          setFieldValue("ShippingAddress", values.BillingAddress);
        }
      }, [values.BillingAddress, values.IsBillingAddressSame]);

      useEffect(() => {
        if (values.IsInfoSame) {
          setFieldValue("ContactPersonName", values.TenantName);
          setFieldValue("ContactEmail", values.Email);
        }
      }, [values.TenantName, values.Email, values.IsInfoSame]);

      return null;
    };

    return (
      <Formik
        initialValues={props2.data}
        onSubmit={handleSubmit}
        validationSchema={organizationDetailValidateSchema}
        validateOnBlur={false}
        enableReinitialize
      >
        {({ values, isValid, setFieldValue }) => (
          <Form id="formBody">
            <FormObserver />
            <div className="pt-3">
              <div className="progress px-1 step-progress">
                <div className={`progress-bar w-100`} role="progressbar"></div>
              </div>
              <div className="step-container d-flex justify-content-between">
                <div className="step completed">
                  <div className="step-circle">
                    <svg
                      id="fi_3031282"
                      enable-background="new 0 0 460.702 460.702"
                      fill="currentColor"
                      viewBox="0 0 460.702 460.702"
                    >
                      <g>
                        <path d="m316.608 121.805c-8.937-9.037-23.499-9.151-32.576-.254l-170.268 168.282-74.017-76.626c-8.828-9.201-23.443-9.503-32.643-.675-9.201 8.828-9.503 23.443-.675 32.643.04.041.079.082.119.123l90.248 93.526c4.319 4.406 10.222 6.901 16.392 6.926h.254c6.053-.019 11.857-2.415 16.161-6.672l186.797-184.697c9.025-8.95 9.117-23.511.208-32.576z"></path>
                        <path d="m235.318 338.824c4.308 4.395 10.192 6.888 16.346 6.926h.254c6.053-.019 11.857-2.415 16.161-6.672l186.798-184.697c8.467-9.534 7.602-24.126-1.931-32.593-8.643-7.676-21.63-7.777-30.391-.237l-170.199 168.282-6.072-6.303c-8.827-9.201-23.442-9.504-32.643-.676-9.201 8.827-9.504 23.442-.676 32.643.04.042.08.083.12.124z"></path>
                      </g>
                    </svg>
                  </div>{" "}
                  <FormattedMessage id="user_information" />
                </div>
                <div className="step active">
                  <div className="step-circle">
                    <svg
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 480 480"
                      fill="currentColor"
                    >
                      <g>
                        <path
                          d="M472,464h-48V200c0-4.418-3.582-8-8-8H304V8c0-4.418-3.582-8-8-8H88c-4.418,0-8,3.582-8,8v456H8c-4.418,0-8,3.582-8,8
      s3.582,8,8,8h464c4.418,0,8-3.582,8-8S476.418,464,472,464z M168,464h-32v-72c0-4.418,3.582-8,8-8h16c4.418,0,8,3.582,8,8V464z
        M200,200v264h-16v-72c0-13.255-10.745-24-24-24h-16c-13.255,0-24,10.745-24,24v72H96V16h192v176h-80
      C203.582,192,200,195.582,200,200z M408,464H216V208h192V464z"
                        ></path>
                        <path
                          d="M256,112h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C264,115.582,260.418,112,256,112z
        M248,160h-32v-32h32V160z"
                        ></path>
                        <path
                          d="M256,32h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V40C264,35.582,260.418,32,256,32z
        M248,80h-32V48h32V80z"
                        ></path>
                        <path
                          d="M176,112h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C184,115.582,180.418,112,176,112z
        M168,160h-32v-32h32V160z"
                        ></path>
                        <path
                          d="M176,32h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V40C184,35.582,180.418,32,176,32z
        M168,80h-32V48h32V80z"
                        ></path>
                        <path
                          d="M176,192h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C184,195.582,180.418,192,176,192z
        M168,240h-32v-32h32V240z"
                        ></path>
                        <path
                          d="M176,272h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-48C184,275.582,180.418,272,176,272z
        M168,320h-32v-32h32V320z"
                        ></path>
                        <path
                          d="M328,368h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C320,364.418,323.582,368,328,368z
        M336,320h32v32h-32V320z"
                        ></path>
                        <path
                          d="M328,288h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C320,284.418,323.582,288,328,288z
        M336,240h32v32h-32V240z"
                        ></path>
                        <path
                          d="M328,448h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C320,444.418,323.582,448,328,448z
        M336,400h32v32h-32V400z"
                        ></path>
                        <path
                          d="M248,368h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C240,364.418,243.582,368,248,368z
        M256,320h32v32h-32V320z"
                        ></path>
                        <path
                          d="M248,288h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C240,284.418,243.582,288,248,288z
        M256,240h32v32h-32V240z"
                        ></path>
                        <path
                          d="M248,448h48c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48C240,444.418,243.582,448,248,448z
        M256,400h32v32h-32V400z"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <FormattedMessage id="organisation_information" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="organization_name"
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-info-circle ms-2"
                    viewBox="0 0 16 16"
                    data-tooltip-id="my-tooltip-org-name"
                    data-tooltip-html={formatMessage("name_validation")}
                    data-tooltip-variant="dark"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                  </svg>
                  <Tooltip
                    id="my-tooltip-org-name"
                    place="bottom"
                    className={
                      getThemeFromLocalStorage() ? "dark-theme-wrap" : ""
                    }
                  />
                  <Field
                    data-testid="OrganizationName"
                    className="form-control"
                    name="OrganizationName"
                    placeholder="organization_name"
                    type="text"
                    validcharacter={["@", "#", "$", "-", "_", "."]}
                    as={FormikFormInput}
                    onBlur={
                      props.Id > 0
                        ? undefined
                        : (e: React.FocusEvent<HTMLInputElement>) => {
                            if (e.target.value.trim() === "") {
                              e.target.value = "";
                            }
                            if (e.target.value.trim().length > 0) {
                              GenerateOrgIdForTenantService(
                                e.target.value,
                                (generatedId: string) => {
                                  setFieldValue("OrganizationId", generatedId);
                                }
                              );
                            }
                          }
                    }
                  />
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="organization_id"
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-info-circle ms-2"
                    viewBox="0 0 16 16"
                    data-tooltip-id="my-tooltip-org-id"
                    data-tooltip-html={formatMessage("org_id_valid_chars")}
                    data-tooltip-variant="dark"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                  </svg>
                  <Tooltip
                    id="my-tooltip-org-id"
                    place="bottom"
                    className={
                      getThemeFromLocalStorage() ? "dark-theme-wrap" : ""
                    }
                  />
                  <Field
                    data-testid="OrganizationId"
                    className="form-control"
                    name="OrganizationId"
                    placeholder="organization_id"
                    invalidcharacter={[" "]}
                    as={FormikFormInput}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    // required={true}
                    label="vat_no"
                  />
                  <Field
                    data-testid="VatNo"
                    className="form-control"
                    name="VatNo"
                    placeholder="vat_no"
                    invalidcharacter={[" "]}
                    as={FormikFormInput}
                  />
                </div>
              </div>
              <div className="col-12 my-1">
                <div className="checkbox">
                  <label>
                    <Field
                      data-testid="IsInfoSame"
                      className="form-control"
                      name="IsInfoSame"
                      role="switch"
                      type="checkbox"
                      id="IsInfoSame"
                      as={FormikFormCheckBox}
                    />
                    <span className="cr">
                      <i className="cr-icon fas fa-check"></i>
                    </span>
                  </label>
                  <label htmlFor="IsInfoSame" className="h">
                    <FormattedMessage id="is_info_same" />
                  </label>
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="contact_person_name"
                  />

                  <Field
                    data-testid="ContactPersonName"
                    className="form-control"
                    name="ContactPersonName"
                    placeholder="contact_person_name"
                    type="text"
                    disabled={values.IsInfoSame}
                    as={FormikFormInput}
                  />
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="contact_email"
                  />
                  <Field
                    id="ContactEmail"
                    className="form-control"
                    name="ContactEmail"
                    placeholder="contact_email"
                    type="text"
                    disabled={values.IsInfoSame}
                    invalidcharacter={[" "]}
                    validcharacter={[
                      "-",
                      "_",
                      "[",
                      "]",
                      "(",
                      ")",
                      ":",
                      "#",
                      "@",
                      ".",
                    ]}
                    as={FormikFormInput}
                  />
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={false}
                    label="contact_phone_number"
                  />
                  <Field
                    id="ContactPhoneNumber"
                    className="form-control"
                    name="ContactPhoneNumber"
                    placeholder="contact_phone_number"
                    type="number"
                    as={FormikFormInput}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="billing_address"
                  />
                  <Field
                    rows={2}
                    id="BillingAddress"
                    className="form-control"
                    name="BillingAddress"
                    placeholder="billing_address"
                    type="text"
                    as={FormikFormTextArea}
                  />
                </div>
              </div>
              <div className="col-12 my-1">
                <div className="checkbox">
                  <label>
                    <Field
                      data-testid="IsBillingAddressSame"
                      className="form-control"
                      name="IsBillingAddressSame"
                      role="switch"
                      type="checkbox"
                      id="IsBillingAddressSame"
                      as={FormikFormCheckBox}
                    />
                    <span className="cr">
                      <i className="cr-icon fas fa-check"></i>
                    </span>
                  </label>
                  <label htmlFor="IsBillingAddressSame" className="h">
                    <FormattedMessage id="is_billing_address_same" />
                  </label>
                </div>
              </div>
              <div
                className={`col-12 ${values.IsBillingAddressSame} billing_wrap`}
              >
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="shipping_address"
                  />
                  <Field
                    rows={2}
                    id="ShippingAddress"
                    className="form-control"
                    name="ShippingAddress"
                    disabled={values.IsBillingAddressSame}
                    placeholder="shipping_address"
                    type="text"
                    as={FormikFormTextArea}
                  />
                </div>
              </div>
            </div>
            <div className="pb-3 d-flex justify-content-center">
              <Button
                data-testid="back"
                variant="secondary"
                type={isValid ? "button" : "submit"}
                onClick={() => {
                  if (props.Id > 0) {
                    if (isValid) props2.prev(values);
                  } else {
                    props2.prev(values);
                  }
                }}
                disabled={props.isLoading}
                className="me-3"
              >
                <FormattedMessage id="back" />
              </Button>

              <LoaderButton
                type="submit"
                id="SaveTenant"
                isLoading={props.isLoading}
                text={props.Id === -1 ? "submit" : "update"}
              />
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  const steps = [
    <StepOne
      next={handleNextStep}
      data={data}
      Id={props.Id}
      isLoading={isLoading}
    />,
    <StepTwo
      next={handleNextStep}
      prev={handlePrevStep}
      data={data}
      Id={props.Id}
      isLoading={isLoading}
    />,
  ];

  return (
    <div>
      {isLoading && <FormLoader loading={isLoading} />}
      {steps[currentStep]}
    </div>
  );
};

export default observer(AddUpdateTenantForm1);
